
import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },

  computed: {
    ...mapGetters({
      openCommentsFilter: "global/getCommentsModal",
    }),
  },

  mounted() {},

  methods: {
    apply() {
      this.$emit("apply");
    },

    resetFilter() {
      this.$root.$emit("sidebar-reset");
      this.$emit("resetFilters");
    },
  },
};
